<template>
  <div id="app">

    <div id="content-wrapper">

      <Legal v-if="isShowingLegal" />

      <span :class="isShowingLegal ? 'hide' : '' " >
        <div class="confetti-bg">
          <canvas id="confettiBgCanvas" ref="confettiBgCanvas"></canvas>
        </div>
        <div id="egg-stage">
          <Egg 
            :class="[showEgg ? '' : 'hide', 'left']"
            :eggUrl="'egg_left'"
            :eggType="EggType.LEFT"
          />
          <Egg 
            :class="[showEgg ? '' : 'hide', 'right']"
            :eggUrl="'egg_right'"
            :eggType="EggType.RIGHT"
          />
          <Egg 
            :class="showEgg ? '' : 'hide' "
          />
        </div>
        <router-view />
      </span>

      <div id="footer">
        <div class="footer-section">

          <div class="rules-content">
            <p class="footer-content">
              *No Purchase Necessary. Must be a legal resident of Canada, excluding Quebec, and be age of majority in jurisdiction of residence. Open March 8, 2021 and closes at 11:59:59 PM ET on April 4, 2021. Up to 250 winners will be randomly selected within the website during the campaign period, and instantly notified if they are deemed a winner on the website. 1,134 Prizes available to be won, each consisting of either 1 bag of REESE Easter Chocolate Candy Peanut Butter Eggs, 185 Gram (approx. retail value of each: CAD $5.00), 1 bag of REESE Easter Chocolate Candy Peanut Butter Eggs, 670g (approximate value CAD $14.00 each), HERSHEY Chocolate Crème 3D Candy Egg, 34g (approximate value CAD $1.25) or HERSHEY COOKIES N CRÈME 3D Candy Egg 4 Pack, 136g (approximate value CAD $4.79)Odds of winning depend on the number of eligible entries received before April 4, 2021. Mathematical skill-testing question required. Full rules <a @click.prevent="toggleLegal('legal')">here</a>.
              <!-- *No Purchase Necessary. Must be a legal resident of Canada, excluding Quebec, and be age of majority in jurisdiction of residence. Open March 30, 2020 and closes at 11:59:59 PM ET on April 12, 2020. Up to 250 winners will be randomly selected within the website during the campaign period, and instantly notified if they are deemed a winner on the website. 250 Prizes available to be won, each consisting of 1 bag of REESE Easter Chocolate Candy Peanut Butter Eggs, 185 Gram (approx. retail value of each: CAD $5.00). Odds of winning depend on the number of eligible entries received before April 26, 2020. Mathematical skill-testing question required. Full rules <a @click.prevent="toggleLegal('legal')">here</a>. -->
            </p>
            <!-- <p class="footer-content">
              No Purchase Necessary. Must be a legal resident of Canada, excluding Quebec, and be age of majority in jurisdiction of residence. Open March 30, 2020 and closes at 11:59:59 PM ET on April 26, 2020
            </p> -->
          </div>

        </div>

        <!-- <div class="rules-content footer-section">
          <p class="footer-content">Campaign Period: Entries will be accepted online starting on March 16 2020 at 12:00:01 AM Eastern Time (ET) and ending April 12 2020 at 11:59:59 PM (ET). All online entries must be received by April 12 2020 at 11:59:59 PM (ET)
          </p>
        </div> -->

        <div class="footer-buttons">
          <h3
            @click="privacyNav()"
            :class="[
                      'right', 'footer-btn',
                    ]"
          >Privacy Policy</h3>


          <h3
            @click="toggleLegal('legal')"
            :class="[
                      'left', 'footer-btn',
                      isShowingLegal & legalState !== 'legal' ? 'hidden' : '',
                      isShowingLegal & legalState == 'legal' ? 'active' : ''
                    ]"
          >Legal</h3>
        </div>

      </div>



    </div>





  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex';
// import SvgStroke from '../public/assets/stroke.svg'

import confetti from 'canvas-confetti';

import { EggType } from '@/components/data/Data';
import Egg from './components/shared/Egg'
import Legal from './views/Legal';

export default {
  components: {
    Legal,
    Egg,
    // SvgStroke
  },

  data() {
    return {
      EggType: EggType
    }
  },

  computed: {
    ...mapGetters([
      'isValidSession',
      'isShowingLegal',
      'isWinner',
      'legalState',
      'isConfettiPlaying',
    ]),

    // confettiPlaying() {
    //   return this.isConfettiPlaying;
    // },

    showEgg(){
      if(
          this.$route.name == 'Results' && this.isWinner ||
          this.$route.name == 'Verification'
      ){
        return false;
      } else {
        return true
      }


    }

  },

  watch: {
    isConfettiPlaying: function(newVal, oldVal) {
      console.log('confettiPlaying: ', newVal);
      console.log('confettiPlaying: ', oldVal);

      if( newVal === true && oldVal === false ) {
        // console.log(this);
        // console.log(this.fireAppConfetti);
        this.fireAppConfetti();
        this.hideConfetti();
      }
    }
  },

  created(){
    this.hasCookie();

  },

  mounted() {
    this.appConfetti = confetti.create(this.$refs.confettiBgCanvas, {resize:true});
  },

  methods: {

    ...mapMutations([
      'invalidSession',
      'validSession',
      'showLegal',
      'hideConfetti',
    ]),

    createCookie(){
      var sessionData = {
        id:'hershey',
        session:'25j_7Sl6xDq2Kc3ym0fmrSSk2xV2XkUkX'
      };

      var currentDate = new Date();
      var todayDate = new Date(currentDate.getFullYear()+'-'+(currentDate.getMonth()+1)+'-'+currentDate.getDate());
      var expiredTime = todayDate.getTime() + (24 * 60 * 60 * 1000);

      this.$cookies.set('hershey', sessionData, new Date(expiredTime));

    },

    hasCookie(){
      this.validSession();
      // if(this.$cookies.get('hershey')){
      //   this.invalidSession();

      //   if(this.$route.name !== 'TryAgain')
      //     this.$router.push({ name: 'TryAgain' })

      // } else {
      //   this.validSession();
      //   this.createCookie();

      // }

    },

    toggleLegal(state){
      let payload = {
        visibilityFlag: !this.isShowingLegal,
        legalHeader: state
      }


      this.showLegal(payload);

    },

    privacyNav(){
      window.open("https://www.thehersheycompany.com/en_us/home/privacy-policy.html", "_blank")
    },

    fireAppConfetti() {
      this.fireConfetti({
        particleCount: 50,
        spread: 50,
        startVelocity: 60,
      });

      this.fireConfetti({
        particleCount: 30,
        spread: 35,
        startVelocity: 50
      });

      this.fireConfetti({
        particleCount: 20,
        spread: 40,
        decay: 0.8
      });
    },

    fireConfetti(opts) {
      let defaults = {
        particleCount: 100,
        spread: 35,
        startVelocity: 60,
        ticks: 300,
        colors: ['#fe5200', '#551e0a', '#fdef14'],
        origin: {
          y: 0.8,
        }
      }

      let options = Object.assign(defaults, opts);
      console.log(options);

      this.appConfetti(options);
    },

  }


}
</script>

<style lang="scss">
@import "./styles/_variables.scss";
@import "./styles/_mixins.scss";

html {
  background: linear-gradient($orange-dark 50%, $yellow);
  overflow: hidden;
  border: solid 10px $yellow;
  position: relative;
  top: 0;

}

body, html, #app {
  padding: 0;
  margin: 0;
  width: calc(100vw - 20px);
  height: calc(100vh - 20px);
  // background: $yellow;
  overflow: hidden;

  @media only screen and (max-width: 600px) {
    font-size: 10.5px;
  }

  @media only screen and (max-width: 325px) {
    font-size: 12px;
  }

  @media only screen and (min-width: 600px) {
    font-size: 15px;
  }

  @media only screen and (min-width: 768px) {
    font-size: 20.5px;
  }


}

*:focus {
    outline: none;
}

.hide {
  visibility: hidden;
  opacity: 0;
}

#egg-stage {
  margin-top: 30vh;
  position: absolute;
  width: 100%;
  height: calc(100% - 30vh);
  pointer-events:none;

}

#svg-wrapper {
    display: inline;
    position: absolute;
    margin: auto;
    height: calc(100% - 20px);
    width: calc(100% - 20px);
    left: 0;
    top: 0;
    z-index: 100;
    pointer-events: none;

    border: solid 10px $yellow;

    #strokeSvgMeta {
      width: 100%;
      height: 100%;
      // position: absolute;
    }

    rect {

      stroke: $yellow;
      stroke-width: 1.75rem;
      fill: none;

      @media screen and (min-width: 0px) and (max-width: 1200px) {
        @include strokeAnimIn;
        stroke-dasharray: 250rem;
        stroke-dashoffset: 250rem;
      }

    }
}

#content-wrapper {
    display: flex;
    flex-direction: column;
    max-width: 550px;
    // align-items: center;
    // align-content: center;
    // justify-content: center;
    margin: auto;
    height: 100%;
    // width: 87.5%;
    width: 100%;
    overflow: hidden;
    position: relative;

}

.page {
  width: 90%;
  margin: auto;
}

#app {
  @include fontStack;
  background: transparent;

  // background-image: linear-gradient($orange-dark 50%, $orange-light);
  display: inline-block;
  padding: 0;
  margin: auto;
  height: 100%;
  width: 100%;
  // border: solid 10px $yellow;


  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;

}

.header, h1, h2 {
  animation-delay: 0.25s;

  font-size: 2.5rem;
  line-height: 1em;

  color: $yellow;
  text-transform: uppercase;
  font-weight: 900;

  &.in {
    @include bounceIn;
    animation-delay: 0.25s;

  }

  &.out {
    @include bounceOut;
    animation-delay: 0.25s;


  }

  @media only screen and (min-width: 768px) {
    max-width: 85%;
  }

}

span {
  display: inline-block;
}

h1 + .sub-copy {
  width: 67.5%;

}

.sub-copy {
  // @include bounceIn;

  &.in {
    @include bounceIn;
    animation-delay: 0.5s;

  }

  &.out {
    @include bounceOut;
    animation-delay: 0.5s;

  }


}

.sub-copy, p, .form-field-wrapper {
  font-size: 1.4rem;
  line-height: 1.35em;
  width: 90%;
  margin: auto;

  color: $brown;
  text-transform: uppercase;
  font-weight: 900;

  span {
    display: inline-block;
  }

}

#footer {
  @include fontStack;
  color: $brown;
  overflow: hidden;
  //background: linear-gradient(rgba(254,242,54, 0), 20%, $yellow);
  background: $yellow;
  padding: 1.25vh 2.25vw 1.25vh;
  text-align: right;
  //height: 5vh;
  position: fixed;
  width: 95vw;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;

  // .right {
  //   margin: auto auto auto 0;
  // }

  // .left {
  //   margin: auto 0 auto auto;
  // }


  h3 {
    color: inherit;
    -webkit-tap-highlight-color: transparent;
    transition: all 0.25s ease-in;

    &.footer-btn {
      font-size: 0.6em;
      background: rgba(254, 242, 54, 0.25);
      flex-shrink: 0;

      &.hidden {
        opacity: 0;
      }

    }

    &.active {
      background: $orange-dark;
      color: $yellow;
    }

    cursor: pointer;
    text-transform: uppercase;
    display: inline-block;
    text-decoration: none;
    margin: 0 1.5vw 0 0;
    cursor: pointer;
    border: solid 2.45px $orange-dark;
    border-radius: 0.35em;
    padding: 0.75em 1em 0.5em 1em;

  }

  .footer-buttons {
    display: flex;
    text-align: center;
    align-items: start;
    justify-content: center;
  }

  // .footer-content {
  //   font-size: 0.75em;

  // }

  .footer-section {
    display: block;
    // display: flex;
    text-align: left;
    // align-items: start;
    width: 96%;
    margin: 0 auto 0 auto;

    &:first-of-type {
      margin-bottom: 0.5em;
    }

    .footer-content {
      font-size: 0.40em;
      margin:  0 auto;
      padding: 0;
      width: 100%;

      @media only screen and (max-height: 600px) {
        font-size: 0.36em;
      }
    }

  }

}

.confetti-bg {
  position: absolute;
  top: 0;
  left: 50%;
  width: 110%;
  height: 100%;
  transform: translateX(-50%);

  canvas {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
}

</style>
